import { useCallback } from "react";
import { Task, TaskStatus } from "@common/types/task";
import { useUpdateTask } from "@api/task.api";
import { useAdvanceToNextTask } from "@components/tasks/useAdvanceToNextTask";
import { useToaster } from "@design-system/ToastMessages/useToaster";

/** Marks the migration upload task done and advances after a successful import. */
export function useCompleteMigrationTask(selectedTask: Task) {
    const { error: toastError } = useToaster();
    const updateTask = useUpdateTask(selectedTask);
    const advanceToNextTask = useAdvanceToNextTask();

    return useCallback(() => {
        updateTask.mutate(
            { status: TaskStatus.DONE },
            {
                onSuccess: () => {
                    advanceToNextTask(selectedTask);
                },
                onError: () => {
                    toastError(
                        "Migration succeeded but failed to update the task status. Mark the task as done manually.",
                    );
                },
            },
        );
    }, [updateTask, advanceToNextTask, selectedTask, toastError]);
}
